<template>
  <password-input
    v-bind="{ label: showLabel, required, classes, placeholder, meter, autocomplete, reveal, revealClass }"
    :value="fieldValue"
    @input="updatePassword"
    :error="$root.errorBag[field]">
    {{ label }}
  </password-input>
</template>
<script>

export default {

  props: {
    meter: {
      type: Boolean,
      default: false
    },

    store: {
      type: String,
      default: 'user'
    },

    field: {
      type: String,
      required: true,
    },

    mutation: {
      type: String,
      required: true
    },
    
    reveal: {
      type: String,
    },

    revealClass: {
      type: String,
    },

    required: Boolean,
    label: String,
    placeholder: String,
    classes: [String, Object, Array],
    autocomplete: String,
  },

  data: () => ({
    showingPassword: false
  }),

  methods: {
    updatePassword(value) {
      this.$store.commit(`${this.store}/${this.mutation}`, value)
    }
  },

  computed: {
    fieldValue() {
      return this.$store.getters[`${this.store}/user`][this.field]
    },

    showLabel() {
      return (this.label?.length > 0)
    }
  }

}
</script>
